export enum DraftPickState {
    CONFIRMED = 'confirmed',
    ON_THE_CLOCK = 'onTheClock',
    OPEN = 'open',
    FORFEIT = 'forfeit',
}
